import { AsyncThunk, AsyncThunkConfig, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchByIdWithoutInputFactory } from "./fetchByIdFactory";
import { Consumption } from "../../Services";
import { gql } from "@apollo/client";

export interface ConsumptionsWithIdentifier {
  target_id: string;
  consumptions: Consumption[]
  count?: number
}


interface ConsumptionByIdsResponse {
  consumption: {
    byIds: ConsumptionsWithIdentifier[]
  }
}

const CONSUMPTION_BY_ID = gql`
  query ConsumptionByIds($domain: String!, $ids: [Int!]!, $amountOfDays: Int) {
    consumption {
      byIds(domain: $domain, ids: $ids, amountOfDays: $amountOfDays) {
        target_id
        consumptions {
          progressed: accumulated_amount
          total: expected_amount
          milestoneDayOffset: milestone_day_offset
          componentId: fk_components
        }
      }
    }
  }
`

export const fetchConsumptionByIdsThunk = createAsyncThunk(
  `consumption/fetchByIds`,
  fetchByIdWithoutInputFactory<ConsumptionByIdsResponse, ConsumptionsWithIdentifier, string>(CONSUMPTION_BY_ID, (consumptionResponse) => consumptionResponse.data.consumption.byIds, (id) => Number(id))
) satisfies AsyncThunk<ConsumptionsWithIdentifier[], string[], AsyncThunkConfig> as AsyncThunk<ConsumptionsWithIdentifier[], string[], AsyncThunkConfig>
